import { FC } from 'react';
import { ConfigProvider, Select as AntSelect, SelectProps } from 'antd';

export const Select: FC<SelectProps> & { Option: typeof AntSelect.Option } = (props) => {
    return (
        <ConfigProvider theme={{
            token: {
                borderRadius: 28,
                colorBorder: '#A6BDFE',
                fontSize: 16
            },
            components: {
                Select: {
                    activeBorderColor: '#205BFC',
                    hoverBorderColor: '#205BFC',
                    optionSelectedBg: '#F1F8FF',
                }
            }
        }}>
        <AntSelect {...props} className={`h-14 ${props.className ? props.className : ''}`} />
        </ConfigProvider>
    );
};

Select.Option = AntSelect.Option;
